import i18n from "i18next";                      
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: 
      {
        translation: 
        {
          nav_menu1:"About us",
          nav_menu2:"Web Sites",
          nav_menu3:"Portfolio",
          nav_menu4:"Our Team",
          nav_menu5:"Contact Us",
          home_title: "Toolsoft Interactive",
          home_text1: "Toolsoft company is dedicated to the creation of Web Sites and Internet Applications. Trained personnel is committed to give quality service to our customers. Our goal of complete customer satisfaction is supported by their positive feedback.",
          home_text2: "This is the right place to start if you need professionally implemented programming solutions for your business.",
          home_text3: "Toolsoft offers professional work, your visitors feel identified with your company.",
          home_text4: "Toolsoft offers the following for your company: sale of domains and hosting, creation of professional designs, online catalogs, shopping carts and billing systems.",
          about_title1:"Vision",
          about_title2:"Mission",
          about_title3:"Values",
          about_text1:"To further consolidate our position as leader in the software market Toolsoft plans to provide its business consulting expertise services to those clients who would like to launch their e-business proyects.",
          about_text2:"Our mission is to meet customer needs and aspirations with impeccable service by demonstrating efficiency, knowledge, professionalism and integrity in our work.",
          about_ul_li1:"Innovation.",
          about_ul_li2:"Responsibility.",
          about_ul_li3:"Quality Services.",
          about_ul_li4:"Efficiency.",
          web_title1:"Domains and Hosting",
          web_text1:"To host your site on the Internet requires a domain and hosting, we sell quality services for your site.",
          web_ul1_li1:"Check your mail on Webmail.",
          web_ul1_li2:"Free e-mail accounts.",
          web_ul1_li3:"CGI, PHP 5, RoR, Perl.",
          web_ul1_li4:"MySQL Database.",
          web_ul1_li5:"FTP Servers.",
          web_ul1_li6:"Servicio de SSH.",
          web_ul1_li7:" Content management system.",
          web_title2:"Web design",
          web_text2:"Toolsoft offers professional work, your visitors feel identified with your company.",
          web_text3:"We offer designs that contain high-quality graphics, while maintaining a short time to download from the Internet.",
          web_text4:"The advantages are:",
          web_ul2_li1:"Exclusive design for your company's image.",
          web_ul2_li2:"Easy to use.",
          web_ul2_li3:"Designs with CSS technology.",
          web_ul2_li4:"Our code is standardized by WC3.",
          web_ul2_li5:"Self-explanatory menus for visitors in your site.",
          web_title3:"Web Applications",
          web_text5:"Toolsoft has a lot of services for your website. We have professional staff to perform custom applications.",
          web_text6:"Our applications exceeds the requirements of your business. We can help you to foster growth and expansion your company.",
          web_text7:"Services for your website:",
          web_ul3_li1:"Registration of customers and users.",
          web_ul3_li2:"Contact forms.",
          web_ul3_li3:"Online catalogs.",
          web_ul3_li4:"Applications GIS inside your Web.",
          port_title1:"Costa Rica Productive Network",
          port_title2:"Yungblut Meats",
          port_title3:"Dell Road Trading",
          port_text1:"It is a website that will facilitate access and analysis of information to visualize economic-productive relationships at the canton level, in order to identify possible opportunities for productive development.",
          port_text2:"Yungblut Meats is a family owned and operated beef farm that has specialized in providing customers with homegrown beef and locally grown pork and chicken products since 1982.",
          port_text3:"Our partnership encompasses over 60 years of combined experience specific to agriculture and food. We have 60 years of hard earned success across a spectrum of the agriculture and food sectors and we want to put all of that experience to work with you.",
          port_link:"View Website",
          team_text1:"Bachelors in Computer Science.",
          team_text2:"Master in Geographic Information Systems and Remote Sensing.",
          team_button1:"Resume Spanish",
          team_button2:"Resume English",
          con_text1:"Full Name",
          con_text2:"Email Address",
          con_text3:"Phone number",
          con_text4:"Mensaje",
          con_text5:"The Message has been sent.",
          con_text6:"Send",
          footer_text1:"Location",
          footer_text2:"Around the Web"
        },
      },
      es: {
        translation: 
        {
            nav_menu1:"Quienes Somos",
            nav_menu2:"Sitios Web",
            nav_menu3:"Portafolio",
            nav_menu4:"Nuestro Equipo",
            nav_menu5:"Contacto",
            home_text1: "Somos una empresa dedicada a la creación de sitios y aplicaciones vía Internet, nosotros nos comprometemos a brindar un servicio de calidad a nuestros clientes, por que contamos con personal capacitado para llevar acabo nuestro trabajo.",
            home_text2: "Toolsoft desarrolla distintos productos de software, como: escritorio, orientado a la web, Geoespacial (GIS). A como también creamos software personalizado a medida que nuestros clientes lo necesiten.",
            home_text3: "Toolsoft ofrece diseños totalmente profesionales, para que los usuarios que visitan su sitio se sientan identificados con su empresa.",
            home_text4: "Toolsoft le ofrece las siguientes proyecciones: venta de dominios y hosting, creación de diseños profesionales, catálogos en línea, carros de compra y sistemas de facturación para su empresa.",
            about_title1:"Visión",
            about_title2:"Misión",
            about_title3:"Valores",
            about_text1:"Consolidar el liderazgo de Toolsoft en el mercado, expandiéndose en servicios de desarrollo de software. Distinguirnos por la calidad de nuestros proyectos a nivel mundial.",
            about_text2:"Nuestra misión es servir a a las necesidades de nuestros clientes, para convertirnos en una empresa de creación de software eficiente y estable. Para llegar hasta nuestra meta, trabajamos constatemente en satisfacer a nuestros clientes.",
            about_ul_li1:"Inovación.",
            about_ul_li2:"Responsabilidad.",
            about_ul_li3:"Calidad.",
            about_ul_li4:"Eficiencia.",
            web_title1:"Dominios y Hosting",
            web_text1:"Para hospedar su sitio en Internet se requiere un dominio y hosting, nosotros vendemos servicios de calidad para la creación de su sitio. Para hosting ofrecemos las siguientes tecnologías:",
            web_ul1_li1:"Revisión del correo vía Webmail.",
            web_ul1_li2:"Cuentas de e-mail ilimitadas.",
            web_ul1_li3:"CGI, PHP 5, RoR, Perl.",
            web_ul1_li4:"Base de Datos MySQL.",
            web_ul1_li5:"Servidores FTP.",
            web_ul1_li6:"Servicio de SSH.",
            web_ul1_li7:"Manejadores de contenido.",
            web_title2:"Diseño Web",
            web_text2:"Toolsoft ofrece diseños totalmente profesionales, para que los usuarios que visitan su sitio se sientan identificados con su empresa.",
            web_text3:"Ofrecemos diseños que contengan alta calidad gráfica, manteniendo un corto tiempo de descarga desde Internet.",
            web_text4:"Las ventajas que ofrecemos a través de nuestros diseños es:",
            web_ul2_li1:"Diseño exclusivo para la imagen de su empresa.",
            web_ul2_li2:"Fácil usabilidad.",
            web_ul2_li3:"Diseños con tecnología CSS.",
            web_ul2_li4:"Nuestros diseños estandarizados por WC3.",
            web_ul2_li5:"Con menús auto explicables para los visitantes de su sitio.",
            web_title3:"Aplicaciones Web",
            web_text5:"Toolsoft ofrece gran cantidad de servicios para su sitio Web, contamos con personal totalmente profesional para realizar aplicaciones personalizadas para su empresa.",
            web_text6:"Realizamos aplicaciones que se ajustan a los requisitos de su empresa, para fomentar el crecimiento y expansión de su empresa.",
            web_text7:"Servicios para su sitio Web:",
            web_ul3_li1:"Registro de clientes y usuarios.",
            web_ul3_li2:"Formularios de contactos.",
            web_ul3_li3:"Catálogos en línea para ofrecer sus productos.",
            web_ul3_li4:"Aplicaciones GIS dentro de su Web.",
            port_title1:"Red Productiva de Costa Rica",
            port_title2:"Yungblut Meats",
            port_title3:"Dell Road Trading",
            port_text1:"Es un sitio web que facilitará el acceso y análisis de información para visualizar las relaciones económico-productivas a nivel de cantones, con el fin de identificar posibles oportunidades de fomento productivo.",
            port_text2:"Yungblut Meats es una granja de carne operada y de propiedad familiar que se ha especializado en brindar a los clientes carne de res de cosecha propia y productos de cerdo y pollo cultivados localmente desde 1982.",
            port_text3:"Nuestra asociación abarca más de 60 años de experiencia combinada específica de la agricultura y la alimentación. Tenemos 60 años de éxito ganado con esfuerzo en un espectro de los sectores agrícola y alimentario y queremos poner toda esa experiencia a trabajar con usted.",
            port_link:"Ver Sitio Web",
            team_text1:"Bachillerato en Ciencias de la Computación.",
            team_text2:"Master en Sistemas de Información Geográfica y Teledetección.",
            team_button1:"CV Español",
            team_button2:"CV Inglés",
            con_text1:"Nombre Completo",
            con_text2:"Dirección de Correo Electrónico",
            con_text3:"Número de Teléfono",
            con_text4:"Mensaje",
            con_text5:"El Mensaje ha sido enviado.",
            con_text6:"Enviar",
            footer_text1:"Ubicación",
            footer_text2:"Enlaces"
        },
      },
    },
  });

export default i18n;